import React from "react";
import { InitiatePaymentService } from "../multiple-payment/initiate-payment-service";
import { store } from "../../../helpers/store";
import { connect } from "react-redux";
import { history } from "../../../helpers/index";
import { routePaths } from "../../config/route-paths";
import { appService } from "../../../services/app.service";
import { PaymentConfirmationComponent } from "../payment-confirmation/payment-confirmation";
import { accountDetailsWithApiCall } from "../../../actions/home.action";
import { Typography } from "@material-ui/core";
import { CircularProgress,Grid } from "@material-ui/core";

let nodataLabel = {};
if (appService.getLabels()) {
  nodataLabel = appService.getLabels().getLabels.CONFIGURATIONS;
}
class PaymentConfirmationCreditCard extends React.Component {
  constructor(props) {
    super();
    this.state = {
      response: props.response || {},
      location: null,
      contentRes: "",
      waitContent: "",
      error: null,
      loading: true
    };
  }

  componentDidMount() {
    console.log("Full response from parent:", this.state.response);
    // NEED TO PASS BOTH COMPLETE RESP AND ALSO UUID FOR VALIDATION IN MAIN FUNCTION 
    if (this.props.contentRes) {
      this.setState({
        contentRes: this.props.contentRes,
      });
      this.setState({
        waitContent: this.props.contentRes.find(
          (item) => item.contentCode === "PAYMENT_WAIT_MESSAGE"
        ),
      });
    }
    let creditCardGatewayCode = localStorage.getItem("creditCardGatewayCode");
    let connectionId = [];

    if (sessionStorage.getItem("PaymentConnections")) {
      let PaymentConnections = JSON.parse(
        sessionStorage.getItem("PaymentConnections")
      );
      PaymentConnections.forEach((element) => {
        connectionId.push(element.ConnectionId);
      });
    }
    const RequestInput = {completeResponse: this.state.response.completeResponse,transaction_uuid:this.state.response.transaction_uuid}; //add uuid
    let billId = localStorage.getItem("billID");
    if (this.state.response && Object.keys(this.state.response).length > 0) {
      if (billId) {
        let accountId = localStorage.getItem("accountId");
        InitiatePaymentService.postPaymentProcessingCreditBillPay(
          creditCardGatewayCode,
          accountId,
          RequestInput
        ).then(
          (res) => {
            this.setState({
              response: res,
              location: "billpay",
              loading: false
            });
            store.getState().snackbar = false;
            console.log("Payment response for bill pay:", res);
            this.props.accountDetailsWithApiCall();
          },
          (error) => {
            if (error?.response?.status === 400) {
              if (error?.response?.data?.message) {
                let errorCode = error.response.data.message;
                if (errorCode == "ORDER_NOT_FOUND") {
                  this.setState({ error: "Your order does not found",loading: false });
                } else if (errorCode == "INVALID_GATEWAY_CODE") {
                  this.setState({ error: "Invalid Gateway Code",loading: false });
                } else if (errorCode == "ORDER_ID_MISSING") {
                  this.setState({ error: "Order id is missing",loading: false });
                } else {
                  this.setState({
                    error: errorCode
                      ? errorCode
                      : "Error occurred: Transaction not successful",
                      loading: false
                  });
                }
              }
            } else {
              this.setState({
                error: "Error occurred: Transaction not successful",
                loading: false
              });
            }
          }
        );
        localStorage.removeItem("accountId");
        localStorage.removeItem("orderId");
        localStorage.removeItem("billID");
        sessionStorage.removeItem("PaymentConnections");
      } else {
        InitiatePaymentService.postPaymentProcessingPay(
          creditCardGatewayCode,
          RequestInput
        ).then(
          (res) => {
            this.setState({
              response: res.data.data.postPaymentProcessing,
              location: "payment",
              loading: false
            });
            console.log("Payment response for payment:", res);
            store.getState().snackbar = false;
            this.props.accountDetailsWithApiCall();
          },
          (error) => {
            console.log("Error response:", error);
            if (error?.response?.status === 400) {
              if (error?.response?.data?.errors?.[0]?.message) {
                let errorCode = error.response.data.errors[0].message;
                if (errorCode == "ORDER_NOT_FOUND") {
                  this.setState({ error: "Your order does not found", loading: false });
                } else if (errorCode == "INVALID_GATEWAY_CODE") {
                  this.setState({ error: "Invalid Gateway Code",loading: false });
                } else if (errorCode == "ORDER_ID_MISSING") {
                  this.setState({ error: "Order id is missing",loading: false });
                } else {
                  this.setState({
                    error: errorCode
                      ? errorCode
                      : "Error occurred: Transaction not successful",
                      loading:false
                  });
                }
              }
            } else {
              console.log(this.state);
              this.setState({
                error: "Error occurred: Transaction not successful",
                loading: false
              });
            }
          }
        );
        localStorage.removeItem("accountId");
        localStorage.removeItem("orderId");
        localStorage.removeItem("billID");
        sessionStorage.removeItem("PaymentConnections");
      }
    } else {
      localStorage.removeItem("accountId");
      localStorage.removeItem("orderId");
      localStorage.removeItem("billID");
      sessionStorage.removeItem("PaymentConnections");
      if (billId) {
        history.push(routePaths.BILL_DETAILS);
      } else {
        history.push(routePaths.INITIATE_PAYMENT);
      }
    }
  }

  render() {
     return this.state.loading ? (
        <Grid
          container
          alignItems="center"
          style={{
            minHeight: "50vh",
            backgroundColor: "white",
            borderRadius: "10px"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ textAlign: "center" }}>
              Processing your payment...
            </Typography>
            <Typography variant="subtitle2" style={{ textAlign: "center" }}>
              Please don't refresh the page or navigate other page.
            </Typography>
          </Grid>
        </Grid>
  ) : (
      <div>
        {this.state.response && this.state.response.mainData ? (
          <PaymentConfirmationComponent response={this.state} />
        ) : (
          <Typography
            align="center"
            color="primary"
            variant="h6"
            className="noDataFound"
          >
            {this.state.error
              ? this.state.error
              : this.state.waitContent
              ? this.state.waitContent.answer
              : null}
          </Typography>
        )}
      </div>
    );
  }
}

const mapDispachToProps = {
  accountDetailsWithApiCall,
};
const connectedApp = connect(
  null,
  mapDispachToProps
)(PaymentConfirmationCreditCard);
export { connectedApp as PaymentConfirmationCreditCard };
